import { Box } from '@chakra-ui/react';

import { LoaderIcon } from 'Asset/icon';

import styles from './styles.module.css';

const TableLoading = () => {
  return (
    <Box data-testid="stock__table-skeleton" className={styles['table-loader__container']}>
      <Box className={styles['table-loader__box--icon']}>
        <LoaderIcon />
      </Box>
    </Box>
  );
};

export default TableLoading;
